namespace GeniuzPOS.AdvPromo {
    export class PsAdvPromoItem3Columns {
        static columnsKey = 'AdvPromo.PsAdvPromoItem3';
    }
}
